import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import quoteImage from '../../assets/img/005.jpg';

const MessageLimitNotice = ({ onClose }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Box sx={{ p: 4, textAlign: 'center' }}>
      <img
        src={quoteImage}
        alt="Quote"
        style={{ width: 70, height: 'auto', borderRadius: '8px', marginBottom: 6 }}
      />
      <Typography variant="h4" sx={{ mb: 1 }}>
        {t('message_limit_title')}
      </Typography>
      <Typography variant="body" sx={{ lineHeight: '1.6em', fontSize: 18 }}>
        {t('message_limit_description')}
      </Typography>
      <Button
        variant="contained"
        color="primary"
        sx={{ mt: 2, fontSize: 16 }}
        fullWidth
        onClick={() => {
          onClose();
          navigate('/subscribe');
        }}
      >
        {t('message_limit_cta')}
      </Button>
    </Box>
  );
};

export default MessageLimitNotice;
